import UserContext from 'Context/UserProvider';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { hasSharedInfrastructureOnly, isChargePointOperator } from 'utils/categoryUtils';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Button, Collapse } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useApiService } from '../../../../../services/ApiService/ApiService';
import toast from 'react-hot-toast';

function BusinessInfoDropList(props: any) {
    const [active, setActive] = useState(false);
    const { userInfo, setUserInfo, selectedProduct } = useContext(UserContext);
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();
    const closeModal = props.closeModal;
    const { fetchWithAuth } = useApiService();

    async function selectFleet(businessUuid: string, fleetUuid: any, fleetName: any) {
        try {
            const response = await fetchWithAuth('/fleet/active/set', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: fleetUuid,
                    businessUuid: businessUuid,
                    accountUuid: userInfo.accountUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to set active fleet');
            }

            const res_json = await response.json();

            setUserInfo((prev: any) => ({
                ...prev,
                businessName: props.title,
                businessUuid: props.businessUuid,
                fleetUuid: fleetUuid,
                currentFleetName: fleetName,
                businessProducts: props.businessProducts,
                businessCategory: res_json.fleet?.businessCategory
            }));

            closeModal();
            window.location.reload();
        } catch (error) {
            console.error('Error setting active fleet:', error);
            setIsError(true);
            toast.error('Failed to set active fleet');
        }
    }

    return (
        <Box>
            {isChargePointOperator(props.chargingCategory) || hasSharedInfrastructureOnly(props.chargingCategory) ? (
                <ListItem disablePadding>
                    <ListItemButton onClick={() => selectFleet(props.businessUuid, props.uuid, props.title)}>
                        <ListItemText 
                            primary={props.title}
                            sx={{
                                '& .MuiTypography-root': {
                                    textDecoration: 'underline',
                                }
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            ) : (
                <>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => setActive(!active)}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                                <AddCircleOutlineIcon />
                            </ListItemIcon>
                            <ListItemText primary={props.title} />
                            {active ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={active} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {props.list.length > 0 ? (
                                props.list.map((item: any, index: any) => (
                                    <ListItem key={index} disablePadding>
                                        <ListItemButton 
                                            onClick={() => selectFleet(props.businessUuid, item.uuid, item.name)}
                                            sx={{ pl: 4 }}
                                        >
                                            <ListItemText primary={item.name} />
                                        </ListItemButton>
                                    </ListItem>
                                ))
                            ) : (
                                <ListItem sx={{ flexDirection: 'column', alignItems: 'flex-start', pl: 4 }}>
                                    <Typography variant="body2" sx={{ my: 1 }}>
                                        There is not yet any fleet in this business
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            navigate('/common/add-business-fleet', {
                                                state: {
                                                    optionCategory: [false, true],
                                                    business: { uuid: props.uuid, name: props.title }
                                                }
                                            });
                                            closeModal();
                                        }}
                                    >
                                        Add Fleet
                                    </Button>
                                </ListItem>
                            )}
                        </List>
                    </Collapse>
                </>
            )}
        </Box>
    );
}

export default BusinessInfoDropList;
